<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import AdminItem from '../AdminItem/AdminItem.vue';
import Fake from '../Fake/Fake.vue';

export default Vue.extend({
    components: {
        AdminItem,
        Fake
    },
    computed: {
        ...mapState({
            loading: state => state.admin.users.loading,
            noContent: state => state.admin.users.noContent,
            error: state => state.admin.users.error,
            users: state => state.admin.users.users,
            user: state => state.admin.users.user,
            list: state => state.admin.users.list,
        }),
    },
    created() {
        window.addEventListener('keyup', this.keyPress);
    },
    methods: {
        ...mapActions({
            setUser: 'admin/setUser',
            toggleEditModal: 'admin/toggleEditModal',
            toggleCreateModal: 'admin/toggleCreateModal'
        }),
        updateUser(user) {
            this.setUser(user);
            this.toggleEditModal();
        },
        keyPress(key) {
            if(key.key === 'Escape') {
                this.toggleEditModal(false);
                this.toggleCreateModal(false);
            }
        }
    }
});
</script>
<template>
    <div class="admin-list">
        <div v-if="!loading" class="admin-list__content">
            <div class="admin-list__header">
                <div class="admin-list__heading">
                    {{ $t('admin.list.header.heading') }}
                </div>
                <div class="admin-list__create-user" @click="toggleCreateModal()">
                    <i class="fa fa-user-plus"/> {{ $t('admin.list.content') }}
                </div>
            </div>
            <table v-if="!loading"
                   class="admin-list__table">
                <thead>
                    <tr>
                        <th>{{ $t('admin.list.id') }}</th>
                        <th>{{ $t('admin.list.firstname') }}</th>
                        <th>{{ $t('admin.list.lastname') }}</th>
                        <th>{{ $t('admin.list.email') }}</th>
                        <th>{{ $t('admin.list.status') }}</th>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users" :key="'admin-user-' + index">
                        <td>{{ user.id }}</td>
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.status }}</td>
                        <td align="right">
                            <span class="admin-list__edit" @click="updateUser(user)">
                                <i class="fa fa-edit"/> {{ $t('admin.list.edit') }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="admin-list__items-list">
                <admin-item v-for="(user, index) in users" :key="'admin-user-item-' + index"
                            :id="user.id"
                            :first-name="user.firstName"
                            :last-name="user.lastName"
                            :email="user.email"
                            :status="user.status"
                            @update="updateUser(user)"/>
            </div>
            <div v-if="!users"
                 :key="'no-content'"
                 class="admin-list__error">
                <i class="fa fa-bullhorn"/>
                <div class="admin-list__error-message">
                    {{ $t('admin.list.noUsers') }}
                </div>
            </div>
        </div>
        <fake v-if="loading"
              :header-rows="1"
              :body-rows="10"
              :body-cells="4"
              :key="'fake'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AdminList/AdminList.vue